import {
    BrowserIcon,
    CardsIcon,
    CubeIcon,
    GearIcon,
    ShapesIcon,
} from '@phosphor-icons/react/dist/ssr';

import type { IntegrationSideContentTemplateProps } from '@/components/templates/IntegrationSideContentTemplate';
import type { SelectMenuType } from '@/components/templates/IntegrationSideContentTemplate/_components/SelectMenu/SelectMenu.types';

export const INTEGRATION_MENU_SELECT_CONFIG_MOBILE_RO: SelectMenuType = {
    placeholder: 'Selectează din listă',
    mobileList: [
        {
            id: '1',
            name: 'Module eCommerce',
            href: '/p/comercianti/integrare/module-ecommerce',
        },
        {
            id: '2',
            name: 'API',
            href: '/p/comercianti/integrare/api',
        },
        {
            id: '3',
            name: 'Pagina de produs',
            href: '/p/comercianti/integrare/pagina-de-produs',
        },
        {
            id: '4',
            name: 'Landing page',
            href: '/p/comercianti/integrare/landing-page',
        },
        {
            id: '5',
            name: 'Logotip',
            href: '/p/comercianti/integrare/logotip',
        },
    ],
};

export const INTEGRATION_SIDE_CONFIG_RO: IntegrationSideContentTemplateProps = {
    listData: [
        {
            title: 'Materiale pentru dezvoltatori',
            id: '1',
            list: [
                {
                    id: '1',
                    name: 'Module eCommerce',
                    Icon: CubeIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/p/comercianti/integrare/module-ecommerce',
                },
                {
                    id: '2',
                    name: 'API',
                    Icon: GearIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/p/comercianti/integrare/api',
                },
            ],
        },
        {
            title: 'Materiale de marketing',
            id: '2',
            list: [
                {
                    id: '1',
                    name: 'Pagina de produs',
                    Icon: CardsIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/p/comercianti/integrare/pagina-de-produs',
                },
                {
                    id: '2',
                    name: 'Landing page',
                    Icon: BrowserIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/p/comercianti/integrare/landing-page',
                },
                {
                    id: '3',
                    name: 'Logotip',
                    Icon: ShapesIcon,
                    iconProps: {
                        'aria-hidden': 'true',
                    },
                    href: '/p/comercianti/integrare/logotip',
                },
            ],
        },
    ],
};
